import { render, staticRenderFns } from "./People.vue?vue&type=template&id=31e66ce0&scoped=true&"
import script from "./People.vue?vue&type=script&lang=js&"
export * from "./People.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e66ce0",
  null
  
)

export default component.exports